export { DeleteModal } from "./DeleteModal";
